import React from "react";

const PreCheckInHomeComponent = (props) => {
  return (
    <div className="w-full flex-1 text-center xxs:text-xl md:text-2xl font-semibold pt-2 pb-2 md:flex-0 flex">
      <div className="w-full">
        <div
          className="flex flex-col justify-center items-center cursor-pointer p-8 border-b"
          style={{
            borderColor: props.appHomeRowDividerColor,
          }}
          onClick={() =>
            props.history.push(
              `/pre-checkin/${props.propertyUid}/booking-code${props.search}`
            )
          }>
          <p
            className="w-full md:text-center mb-4 type-title large"
            style={{ color: props.titleColor }}>
            {props.reservationNumberTitle}
          </p>
          <p
            className="w-full md:text-center leading-1 pt-2 mb-4 type-regular normal"
            style={{ color: props.subtitleColor }}>
            {props.reservationNumberDetail}
          </p>
        </div>
        {["opera_kiosk", "opera_minor_kiosk", "opera_ihg_kiosk"].includes(
          props.pmsInterfaceType
        ) && (
          <div
            className="flex flex-col justify-center items-center cursor-pointer p-8 border-b"
            style={{
              borderColor: props.appHomeRowDividerColor,
            }}
            onClick={() =>
              props.history.push(
                `/pre-checkin/${props.propertyUid}/guest-email${props.search}`
              )
            }>
            <p
              className="w-full md:text-center mb-4 type-title large"
              style={{ color: props.titleColor }}>
              {props.emailAddressTitle}
            </p>
            <p
              className="w-full md:text-center leading-1 pt-2 mb-4 type-regular normal"
              style={{ color: props.subtitleColor }}>
              {props.emailAddressDetail}
            </p>
          </div>
        )}
        {props.pmsInterfaceType === "infor" && (
          <div
            className="flex flex-col justify-center items-center cursor-pointer p-8 border-b"
            style={{
              borderColor: props.appHomeRowDividerColor,
            }}
            onClick={() =>
              props.history.push(
                `/pre-checkin/${props.propertyUid}/guest-name${props.search}`
              )
            }>
            <p
              className="w-full md:text-center mb-4 type-title large"
              style={{ color: props.titleColor }}>
              {props.lastNameTitle}
            </p>
            <p
              className="w-full md:text-center leading-1 pt-2 mb-4 type-regular normal"
              style={{ color: props.subtitleColor }}>
              {props.lastNameDetail}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PreCheckInHomeComponent;
